export { default } from './SkeletonCircle.js';
